import { useSelector } from 'react-redux';

import {
  getIsProductSoldOut,
  getIsFetchProductAvailabilityPending,
} from '../../../store/selectors/product.selectors';
import {
  getIsOnline,
} from '../../../store/selectors/ui.selectors';
import RestockButton from './AddToCart.RestockButton';
import AddToCardButton from './AddToCart.Button';

export interface AddToCartProps {
  showQuantitySelector: boolean;
}

const AddToCart = ({ showQuantitySelector }: AddToCartProps) => {
  const isFetchProductAvailabilityPending = useSelector(getIsFetchProductAvailabilityPending);
  const isOnline = useSelector(getIsOnline);
  const soldOut = useSelector(getIsProductSoldOut);

  return soldOut && !isFetchProductAvailabilityPending && isOnline
    ? <RestockButton />
    : <AddToCardButton showQuantitySelector={showQuantitySelector} />;
};

export default AddToCart;
